define('entities/admin/user_groups',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.UserGroup = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      name: '',
      members: [],
      memberCount: 0
    },

    idAttribute: 'secId'
  });

  App.reqres.setHandler('userGroups:model', function (json) {
    // Reuse the existing instance from the Backbone.Relational store if one
    // already exists for this secId — this is what lets the TableView body
    // diff rows correctly on refetch instead of stacking duplicates.
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.UserGroup, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.UserGroup(json);
  });

  /**
   * REST API
   */
  var API = {
    getListUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userpidgroup', params);
    },

    getRowCountUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userpidgroup/rowCount', params);
    },

    getOneUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/userpidgroup/' + secId);
    },

    getCanEditUrl: function () {
      return Settings.url('compuzz2', 'v2/userpidgroup/canEdit');
    },

    getCreateUrl: function () {
      return Settings.url('compuzz2', 'v2/userpidgroup');
    },

    getAddMemberUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/userpidgroup/' + secId + '/members');
    },

    getRemoveMemberUrl: function (secId, userpidSecId) {
      return Settings.url('compuzz2', 'v2/userpidgroup/' + secId + '/members/' + userpidSecId);
    },

    getUserpidSearchUrl: function (params) {
      return Settings.url('compuzz2', 'v2/userpid', params);
    }
  };

  App.reqres.setHandler('userGroups:get-url', function (params) {
    return API.getListUrl(params);
  });

  App.reqres.setHandler('userGroups:row-count-url', function (params) {
    return API.getRowCountUrl(params);
  });

  App.reqres.setHandler('userGroups:canEdit', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getCanEditUrl(),
      success: function (data) {
        defer.resolve(data && data.canEdit === true);
      },
      error: function (xhr) {
        // Log so it's obvious why editing is blocked (likely missing role).
        if (window.console && console.warn) {
          console.warn('userGroups:canEdit failed', xhr && xhr.status, xhr && xhr.responseText);
        }
        defer.resolve(false);
      }
    });
    return defer.promise();
  });

  App.reqres.setHandler('userGroups:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getOneUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('userGroups:create', function (payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.getCreateUrl(),
      contentType: 'application/json',
      data: JSON.stringify(payload),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Update group settings (currently: hideFromTagging). PUT /{secId}.
  App.reqres.setHandler('userGroups:update', function (secId, body) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: Settings.url('compuzz2', 'v2/userpidgroup/' + secId),
      contentType: 'application/json',
      data: JSON.stringify(body || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('userGroups:add-member', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.getAddMemberUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ userpidSecId: userpidSecId }),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('userGroups:remove-member', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.getRemoveMemberUrl(secId, userpidSecId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('userGroups:search-userpids', function (query) {
    var defer = $.Deferred();
    var params = { pageSize: 20, first: 0 };
    if (query && query.length > 0) {
      // The backend supports firstName/lastName/email filters; send the query to all three
      // and let the user pick. Using firstName gives the most intuitive default.
      params.firstName = query;
    }
    $.ajax({
      type: 'GET',
      url: API.getUserpidSearchUrl(params),
      success: function (data) { defer.resolve(data || []); },
      error: function () { defer.resolve([]); }
    });
    return defer.promise();
  });
});

